import React from "react";
import * as aserver from '../../APIClient';
import * as utils from "../../Utilities";

class ImpersonatedLogin extends React.Component {

      fetchData = async () => {
        let result = await aserver.get(`api/v2/checkForValidSession`);
        if (result.data.allowed) {
          utils.writeCoachDetailsToLocalStorage(result, true)
          aserver.goto('/coachportal/dashboard');
        }
      }

      componentDidMount=()=>{
          this.fetchData()
      }

      render() {
          return (
           <>
            <p>Checking for valid session...</p> 
           </>
          );
      }
      
}

export default ImpersonatedLogin;